<div class="relative flex flex-col w-full h-full">
    <!-- Header -->
    <div class="flex flex-row justify-between flex-auto items-center sm:items-center">
        <div class="text-2xl leading-6 font-bold p-4 flex items-center break-all">
            {{ this.data?.user_id ? this.data?.user_id + ' - Editar' : 'Cadastrar' }} Usuário
        </div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button>
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Form -->
    <div class="flex-1 overflow-auto px-4 py-4">
        <ng-container>
            <div class="w-full" *ngIf="!loadingData; else loadingTemplate">
                <div class="w-full">
                    <form [formGroup]="form">
                        <mat-tab-group class="user-form-tabs" [dynamicHeight]="false" (selectedIndexChange)="onUserTabIndexChange($event)">
                            <mat-tab label="Geral">
                                <div class="py-4">
                        <!-- Foto -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Foto</h3>
                            </div>
                            <div class="flex items-start gap-4">
                                <div
                                    class="w-24 h-24 rounded-full overflow-hidden bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex items-center justify-center shrink-0"
                                >
                                    <img *ngIf="photoDisplayUrl && photoDisplayUrl !== 'pending_upload'" [src]="photoDisplayUrl" alt="Foto" class="w-full h-full object-cover" />
                                    <mat-icon *ngIf="!photoDisplayUrl || photoDisplayUrl === 'pending_upload'" class="text-gray-400" [svgIcon]="'heroicons_outline:user'"></mat-icon>
                                </div>
                                <div class="flex flex-col gap-2">
                                    <input #photoInput type="file" accept="image/*" class="hidden" (change)="onSelectPhoto($event)" />
                                    <button type="button" mat-stroked-button color="primary" (click)="photoInput.click()" [disabled]="uploadingPhoto">
                                        {{ photoDisplayUrl ? 'Trocar foto' : 'Enviar foto' }}
                                    </button>
                                    <button type="button" mat-button color="warn" *ngIf="photoDisplayUrl" (click)="removePhoto()">Remover</button>
                                    <p class="text-xs text-gray-500">JPG ou PNG, até 5MB. Enviada ao salvar.</p>
                                </div>
                            </div>
                        </div>

                        <!-- Dados Pessoais -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Dados pessoais</h3>
                            </div>
                            <div class="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-4">
                                <div class="col-span-3 md:col-span-4 lg:col-span-6">
                                    <mat-form-field class="w-full">
                                        <mat-label>Nome</mat-label>
                                        <input type="text" formControlName="name" matInput />
                                        <mat-error>Campo obrigatório</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3">
                                    <mat-form-field class="w-full">
                                        <mat-label>Data de nascimento</mat-label>
                                        <input matInput [matDatepicker]="birthPicker" formControlName="birth_date" />
                                        <mat-datepicker-toggle matSuffix [for]="birthPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #birthPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3">
                                    <mat-form-field class="w-full">
                                        <mat-label>Idade</mat-label>
                                        <input matInput [value]="ageYears != null ? ageYears + ' anos' : ''" readonly />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3">
                                    <mat-form-field class="w-full">
                                        <mat-label>Estado civil</mat-label>
                                        <mat-select formControlName="marital_status">
                                            <mat-option [value]="null">Selecione</mat-option>
                                            <mat-option *ngFor="let opt of maritalStatusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3">
                                    <mat-form-field class="w-full">
                                        <mat-label>Telefone</mat-label>
                                        <input type="text" formControlName="phone" matInput mask="(00) 00000-0000" placeholder="(00) 00000-0000" [validation]="true" />
                                        <mat-error *ngIf="form.controls.phone?.hasError('required')">Campo obrigatório</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3">
                                    <mat-form-field class="w-full">
                                        <mat-label>Telefone secundário</mat-label>
                                        <input type="text" formControlName="phone_secondary" matInput mask="(00) 00000-0000" placeholder="(00) 00000-0000" />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Email</mat-label>
                                        <input type="email" formControlName="email" matInput autocomplete="off" (input)="onEmailInput()" (blur)="onEmailBlur()" />
                                        <mat-progress-spinner *ngIf="emailCheckLoading" matSuffix diameter="20" mode="indeterminate"></mat-progress-spinner>
                                        <mat-error *ngIf="form.controls.email?.hasError('required')">Campo obrigatório</mat-error>
                                        <mat-error *ngIf="form.controls.email?.hasError('email')">Email inválido</mat-error>
                                        <mat-hint *ngIf="!emailCheckLoading && emailExistsActive && !emailExistsDeleted" class="text-red-600">Email já utilizado por usuário ativo</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Email secundário</mat-label>
                                        <input type="email" formControlName="email_secondary" matInput />
                                        <mat-error *ngIf="form.controls.email_secondary?.hasError('email')">Email inválido</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Documentos de identidade -->
                        <div class="mb-8">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex items-center">
                                    <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                    <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Documentos de identidade</h3>
                                </div>
                                <button
                                    type="button"
                                    class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                    (click)="addIdentityDocument()"
                                    title="Adicionar"
                                >
                                    <mat-icon class="text-white icon-size-5" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                </button>
                            </div>
                            <div class="space-y-3" formArrayName="identity_documents">
                                <div *ngFor="let row of identityDocuments.controls; let i = index" [formGroupName]="i" class="grid grid-cols-12 gap-3 items-start">
                                    <div class="col-span-12 md:col-span-3">
                                        <mat-form-field class="w-full">
                                            <mat-label>Tipo</mat-label>
                                            <mat-select formControlName="doc_type" (selectionChange)="onIdentityDocChange()">
                                                <mat-option *ngFor="let opt of identityDocTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-12 md:col-span-5">
                                        <mat-form-field class="w-full">
                                            <mat-label>Número</mat-label>
                                            <input
                                                matInput
                                                formControlName="doc_number"
                                                [mask]="row.value.doc_type === 'CPF' ? '000.000.000-00' : ''"
                                                (input)="onIdentityDocChange()"
                                                (blur)="onDocBlur()"
                                            />
                                            <mat-hint *ngIf="row.value.doc_type === 'CPF' && docExistsActive" class="text-red-600">CPF já utilizado</mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-10 md:col-span-3">
                                        <mat-form-field class="w-full">
                                            <mat-label>Observação</mat-label>
                                            <input matInput formControlName="observation" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-2 md:col-span-1 flex justify-center md:justify-end items-center self-start mt-6 h-12">
                                        <button type="button" mat-icon-button color="warn" (click)="removeIdentityDocument(i)" [disabled]="identityDocuments.length <= 1" title="Remover">
                                            <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Documentos trabalhistas -->
                        <div class="mb-8">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex items-center">
                                    <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                    <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Documentos trabalhistas</h3>
                                </div>
                                <button
                                    type="button"
                                    class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                    (click)="addLaborDocument()"
                                    title="Adicionar"
                                >
                                    <mat-icon class="text-white icon-size-5" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                </button>
                            </div>
                            <div class="space-y-3" formArrayName="labor_documents">
                                <div *ngFor="let row of laborDocuments.controls; let i = index" [formGroupName]="i" class="grid grid-cols-12 gap-3 items-start">
                                    <div class="col-span-12 md:col-span-3">
                                        <mat-form-field class="w-full">
                                            <mat-label>Tipo</mat-label>
                                            <mat-select formControlName="doc_type">
                                                <mat-option *ngFor="let opt of laborDocTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-12 md:col-span-5">
                                        <mat-form-field class="w-full">
                                            <mat-label>Número</mat-label>
                                            <input matInput formControlName="doc_number" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-10 md:col-span-3">
                                        <mat-form-field class="w-full">
                                            <mat-label>Observação</mat-label>
                                            <input matInput formControlName="observation" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-2 md:col-span-1 flex justify-center md:justify-end items-center self-start mt-6 h-12">
                                        <button type="button" mat-icon-button color="warn" (click)="removeLaborDocument(i)" title="Remover">
                                            <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="laborDocuments.length === 0" class="text-sm text-gray-500">Nenhum documento trabalhista cadastrado.</div>
                            </div>
                        </div>

                        <!-- Vínculo -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Vínculo</h3>
                            </div>
                            <div class="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-4">
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Setor</mat-label>
                                        <input matInput formControlName="sector" />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Gestor</mat-label>
                                        <mat-select formControlName="manager_user_id">
                                            <mat-option [value]="null">Selecione</mat-option>
                                            <mat-option *ngFor="let u of managerOptions" [value]="u.user_id">{{ u.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Cargo</mat-label>
                                        <input matInput formControlName="current_role_title" readonly />
                                        <mat-hint>Vem do histórico de salários</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Admissão</mat-label>
                                        <input matInput [matDatepicker]="admissionPicker" formControlName="admission_date" />
                                        <mat-datepicker-toggle matSuffix [for]="admissionPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #admissionPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Desligamento</mat-label>
                                        <input matInput [matDatepicker]="terminationPicker" formControlName="termination_date" />
                                        <mat-datepicker-toggle matSuffix [for]="terminationPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #terminationPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Endereço -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Endereço</h3>
                            </div>
                            <div class="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-4">
                                <div class="col-span-3 md:col-span-2 lg:col-span-2">
                                    <mat-form-field class="w-full">
                                        <mat-label>CEP</mat-label>
                                        <input type="text" formControlName="cep" matInput mask="00000-000" placeholder="00000-000" [validation]="true" [readonly]="searchingZipCode" />
                                        <button matSuffix mat-icon-button type="button" (click)="searchZipCode()" [disabled]="searchingZipCode" [matTooltip]="'Buscar endereço por CEP'">
                                            <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'" *ngIf="!searchingZipCode"></mat-icon>
                                            <mat-spinner diameter="20" *ngIf="searchingZipCode"></mat-spinner>
                                        </button>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-1 lg:col-span-1">
                                    <mat-form-field class="w-full">
                                        <mat-label>UF</mat-label>
                                        <input type="text" formControlName="uf" matInput maxlength="2" />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Cidade</mat-label>
                                        <input type="text" formControlName="city" matInput />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-5">
                                    <mat-form-field class="w-full">
                                        <mat-label>Bairro</mat-label>
                                        <input type="text" formControlName="neighboorhod" matInput />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-4 lg:col-span-6">
                                    <mat-form-field class="w-full">
                                        <mat-label>Rua</mat-label>
                                        <input type="text" formControlName="street" matInput />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-2">
                                    <mat-form-field class="w-full">
                                        <mat-label>Número</mat-label>
                                        <input type="text" formControlName="number" matInput />
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Complemento</mat-label>
                                        <input type="text" formControlName="complement" matInput />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Dados bancários -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Dados bancários</h3>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <mat-form-field class="w-full">
                                    <mat-label>Banco</mat-label>
                                    <mat-select formControlName="bank_name" (openedChange)="onBankSelectOpened($event, bankFilterInput)">
                                        <mat-option disabled class="bank-filter-option">
                                            <input
                                                #bankFilterInput
                                                [formControl]="bankSearch"
                                                placeholder="Filtrar banco"
                                                class="w-full bg-transparent outline-none text-sm text-gray-900 dark:text-gray-100"
                                                (click)="$event.stopPropagation()"
                                                (keydown)="$event.stopPropagation()"
                                            />
                                        </mat-option>
                                        <mat-option [value]="null">Selecione</mat-option>
                                        <mat-option *ngFor="let opt of filteredBankOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                        <mat-option *ngIf="filteredBankOptions.length === 0" disabled>Nenhum banco encontrado</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Agência</mat-label>
                                    <input matInput formControlName="bank_agency" />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Conta</mat-label>
                                    <input matInput formControlName="bank_account" />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Tipo de conta</mat-label>
                                    <mat-select formControlName="bank_account_type">
                                        <mat-option [value]="null">Selecione</mat-option>
                                        <mat-option *ngFor="let opt of bankAccountTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>PIX</mat-label>
                                    <input matInput formControlName="bank_pix" />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Titular</mat-label>
                                    <input matInput formControlName="bank_holder" />
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Redes -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Redes sociais</h3>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <mat-form-field class="w-full">
                                    <mat-label>Instagram</mat-label>
                                    <input matInput formControlName="social_instagram" placeholder="https://instagram.com/..." />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Facebook</mat-label>
                                    <input matInput formControlName="social_facebook" placeholder="https://facebook.com/..." />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>LinkedIn</mat-label>
                                    <input matInput formControlName="social_linkedin" placeholder="https://linkedin.com/in/..." />
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Contato de emergência -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Contato de emergência</h3>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <mat-form-field class="w-full">
                                    <mat-label>Nome</mat-label>
                                    <input matInput formControlName="emergency_contact_name" />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Telefone</mat-label>
                                    <input matInput formControlName="emergency_contact_phone" mask="(00) 00000-0000" />
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>Parentesco / relação</mat-label>
                                    <input matInput formControlName="emergency_contact_relation" />
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Configurações do Sistema -->
                        <div class="mb-8">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex items-center">
                                    <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                    <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Configurações do sistema</h3>
                                </div>
                                <div *ngIf="!canEditSystemConfig" class="text-xs text-amber-600 dark:text-amber-400 flex items-center gap-1">
                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
                                    <span>Apenas administradores podem alterar</span>
                                </div>
                            </div>
                            <div class="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-4">
                                <div class="col-span-3 md:col-span-3 lg:col-span-4 flex flex-wrap items-center gap-x-6 gap-y-2">
                                    <mat-checkbox formControlName="is_admin">É Administrador?</mat-checkbox>
                                    <mat-slide-toggle formControlName="is_active" color="primary">Usuário ativo</mat-slide-toggle>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Permissão</mat-label>
                                        <mat-select formControlName="permission_id">
                                            <mat-option *ngFor="let option of permissionOptions" [value]="option.permission_id">{{ option?.item }}</mat-option>
                                        </mat-select>
                                        <mat-hint *ngIf="isFormUserAdmin">Administradores usam a permissão "Admin"</mat-hint>
                                        <mat-error *ngIf="form.controls.permission_id?.hasError('required')">Campo obrigatório</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-4" *ngIf="loggedUser.isAdmin && !isFormUserAdmin">
                                    <mat-form-field class="w-full">
                                        <mat-label>Empresa</mat-label>
                                        <mat-select formControlName="company_id">
                                            <mat-option *ngFor="let option of companyOptions" [value]="option.company_id">{{ option?.title }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="form.controls.company_id?.hasError('required')">Campo obrigatório</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-2 lg:col-span-3" *ngIf="selectedPermissionIsSeller">
                                    <mat-form-field class="w-full">
                                        <mat-label>Comissão de Vendas</mat-label>
                                        <input type="number" formControlName="sale_comission" matInput />
                                        <mat-suffix>%</mat-suffix>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-3 md:col-span-3 lg:col-span-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>
                                            <span>Senha</span>
                                            <mat-icon
                                                *ngIf="data?.user_id"
                                                class="icon-size-4 ml-1 text-gray-400 cursor-help"
                                                [matTooltip]="'Preencher este campo irá alterar a senha do usuário'"
                                                [svgIcon]="'heroicons_outline:information-circle'"
                                                inline="true"
                                            ></mat-icon>
                                        </mat-label>
                                        <input type="password" formControlName="password" matInput autocomplete="new-password" />
                                        <mat-error *ngIf="form.controls.password?.hasError('required')">Campo obrigatório</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Observações -->
                        <div class="mb-8">
                            <div class="flex items-center mb-4">
                                <div class="w-1 h-6 bg-gray-500 rounded-full mr-3"></div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Observações</h3>
                            </div>
                            <mat-form-field class="w-full">
                                <mat-label>Observações</mat-label>
                                <textarea formControlName="observation" matInput rows="3"></textarea>
                            </mat-form-field>
                        </div>
                                </div>
                            </mat-tab>
                            <mat-tab label="Anexos" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <app-module-attachments
                                        *ngIf="data?.user_id"
                                        [module]="'USER'"
                                        [entityId]="data.user_id"
                                        [loggedUser]="loggedUser"
                                        [typeFile]="'Documento'"
                                    ></app-module-attachments>
                                </div>
                            </mat-tab>

                            <mat-tab label="Assinaturas" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <app-user-document-signatures
                                        *ngIf="data?.user_id"
                                        [userId]="data.user_id"
                                        [loggedUser]="loggedUser"
                                    ></app-user-document-signatures>
                                </div>
                            </mat-tab>

                            <mat-tab label="Salários e cargos" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <div class="mb-4 flex items-center justify-between">
                                        <div>
                                            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Histórico de salários e cargos</h3>
                                            <p class="text-xs text-gray-500">Registros de cargo e remuneração deste usuário.</p>
                                        </div>
                                        <button
                                            type="button"
                                            class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                            (click)="openSalaryHistoryForm()"
                                            title="Adicionar"
                                        >
                                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="loadingSalaryHistory" class="flex justify-center py-10">
                                        <mat-spinner diameter="36"></mat-spinner>
                                    </div>
                                    <div
                                        *ngIf="!loadingSalaryHistory"
                                        class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/60 dark:border-gray-700/60 overflow-hidden"
                                    >
                                        <div class="divide-y divide-gray-200/60 dark:divide-gray-700/60">
                                            <div
                                                *ngFor="let item of salaryHistory"
                                                class="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer flex items-center justify-between gap-3"
                                                (click)="openSalaryHistoryForm(item)"
                                            >
                                                <div class="min-w-0">
                                                    <p class="font-medium text-gray-900 dark:text-gray-100">{{ item.role_title }}</p>
                                                    <p class="text-sm text-gray-500">
                                                        {{ formatBrl(item.salary_brl) }} · {{ formatDateOnly(item.start_date) }}
                                                        <span *ngIf="item.end_date"> → {{ formatDateOnly(item.end_date) }}</span>
                                                    </p>
                                                </div>
                                                <button mat-icon-button color="warn" type="button" (click)="deleteSalaryHistory(item, $event)" title="Remover">
                                                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                </button>
                                            </div>
                                            <div *ngIf="salaryHistory.length === 0" class="px-4 py-10 text-center text-sm text-gray-500">
                                                Nenhum registro cadastrado.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Banco de horas" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <div class="mb-4 flex items-center justify-between">
                                        <div>
                                            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Histórico de banco de horas</h3>
                                            <p class="text-xs text-gray-500">Créditos e débitos de horas.</p>
                                        </div>
                                        <button
                                            type="button"
                                            class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                            (click)="openHourBankForm()"
                                            title="Adicionar"
                                        >
                                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>

                                    <div *ngIf="!loadingHourBank" class="grid grid-cols-3 gap-3 mb-4">
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Saldo</p>
                                            <p
                                                class="text-lg font-bold"
                                                [ngClass]="
                                                    hourBankKpis.balance >= 0
                                                        ? 'text-blue-600 dark:text-blue-400'
                                                        : 'text-red-600 dark:text-red-400'
                                                "
                                            >
                                                {{ formatHours(hourBankKpis.balance) }}
                                            </p>
                                        </div>
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Entrada</p>
                                            <p class="text-lg font-bold text-green-600 dark:text-green-400">
                                                {{ formatHours(hourBankKpis.entrada) }}
                                            </p>
                                        </div>
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Saída</p>
                                            <p class="text-lg font-bold text-red-600 dark:text-red-400">
                                                {{ formatHours(hourBankKpis.saida) }}
                                            </p>
                                        </div>
                                    </div>

                                    <div *ngIf="loadingHourBank" class="flex justify-center py-10">
                                        <mat-spinner diameter="36"></mat-spinner>
                                    </div>
                                    <div
                                        *ngIf="!loadingHourBank"
                                        class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/60 dark:border-gray-700/60 overflow-hidden"
                                    >
                                        <div class="divide-y divide-gray-200/60 dark:divide-gray-700/60">
                                            <div
                                                *ngFor="let item of hourBank"
                                                class="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer flex items-center justify-between gap-3"
                                                (click)="openHourBankForm(item)"
                                            >
                                                <div class="min-w-0">
                                                    <p class="font-medium text-gray-900 dark:text-gray-100">
                                                        {{ hourBankTypeLabel(item.entry_type) }} · {{ item.hours }}h
                                                    </p>
                                                    <p class="text-sm text-gray-500">{{ formatDateOnly(item.entry_date) }}</p>
                                                </div>
                                                <div class="flex items-center gap-1 shrink-0">
                                                    <button
                                                        *ngIf="hourBankAttachmentById[item.user_hour_bank_id]"
                                                        mat-icon-button
                                                        type="button"
                                                        (click)="downloadRhAttachment(hourBankAttachmentById[item.user_hour_bank_id], $event)"
                                                        title="Baixar anexo"
                                                        matTooltip="Baixar anexo"
                                                    >
                                                        <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                                                    </button>
                                                    <button mat-icon-button color="warn" type="button" (click)="deleteHourBank(item, $event)" title="Remover">
                                                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div *ngIf="hourBank.length === 0" class="px-4 py-10 text-center text-sm text-gray-500">
                                                Nenhum lançamento cadastrado.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Advertências" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <div class="mb-4 flex items-center justify-between">
                                        <div>
                                            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Histórico de advertências</h3>
                                            <p class="text-xs text-gray-500">Advertências registradas para este usuário.</p>
                                        </div>
                                        <button
                                            type="button"
                                            class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                            (click)="openWarningForm()"
                                            title="Adicionar"
                                        >
                                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="loadingWarnings" class="flex justify-center py-10">
                                        <mat-spinner diameter="36"></mat-spinner>
                                    </div>
                                    <div
                                        *ngIf="!loadingWarnings"
                                        class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/60 dark:border-gray-700/60 overflow-hidden"
                                    >
                                        <div class="divide-y divide-gray-200/60 dark:divide-gray-700/60">
                                            <div
                                                *ngFor="let item of warnings"
                                                class="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer flex items-center justify-between gap-3"
                                                (click)="openWarningForm(item)"
                                            >
                                                <div class="min-w-0">
                                                    <p class="font-medium text-gray-900 dark:text-gray-100">{{ item.reason }}</p>
                                                    <p class="text-sm text-gray-500">
                                                        {{ formatDateOnly(item.warning_date) }} · {{ warningSeverityLabel(item.severity) }}
                                                    </p>
                                                </div>
                                                <div class="flex items-center gap-1 shrink-0">
                                                    <button
                                                        *ngIf="warningAttachmentById[item.user_warning_id]"
                                                        mat-icon-button
                                                        type="button"
                                                        (click)="downloadRhAttachment(warningAttachmentById[item.user_warning_id], $event)"
                                                        title="Baixar anexo"
                                                        matTooltip="Baixar anexo"
                                                    >
                                                        <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                                                    </button>
                                                    <button mat-icon-button color="warn" type="button" (click)="deleteWarning(item, $event)" title="Remover">
                                                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div *ngIf="warnings.length === 0" class="px-4 py-10 text-center text-sm text-gray-500">
                                                Nenhuma advertência cadastrada.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Financeiro" [disabled]="!data?.user_id">
                                <div class="py-4">
                                    <div class="mb-4 flex items-center justify-between">
                                        <div>
                                            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Lançamentos financeiros</h3>
                                            <p class="text-xs text-gray-500">Salários, bônus e descontos vinculados a este funcionário.</p>
                                        </div>
                                        <button
                                            type="button"
                                            class="w-10 h-10 bg-blue-600 rounded-lg shadow-sm flex items-center justify-center hover:bg-blue-700"
                                            (click)="openEmployeeFinanceForm()"
                                            title="Adicionar"
                                        >
                                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </div>

                                    <div *ngIf="!loadingEmployeeFinances" class="grid grid-cols-3 gap-3 mb-4">
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Saldo</p>
                                            <p
                                                class="text-lg font-bold"
                                                [ngClass]="
                                                    employeeFinanceKpis.balance >= 0
                                                        ? 'text-blue-600 dark:text-blue-400'
                                                        : 'text-red-600 dark:text-red-400'
                                                "
                                            >
                                                {{ formatBrl(employeeFinanceKpis.balance) }}
                                            </p>
                                        </div>
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Entrada</p>
                                            <p class="text-lg font-bold text-green-600 dark:text-green-400">
                                                {{ formatBrl(employeeFinanceKpis.entrada) }}
                                            </p>
                                        </div>
                                        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                            <p class="text-xs text-gray-500">Saída</p>
                                            <p class="text-lg font-bold text-red-600 dark:text-red-400">
                                                {{ formatBrl(employeeFinanceKpis.saida) }}
                                            </p>
                                        </div>
                                    </div>

                                    <div *ngIf="loadingEmployeeFinances" class="flex justify-center py-10">
                                        <mat-spinner diameter="36"></mat-spinner>
                                    </div>
                                    <div
                                        *ngIf="!loadingEmployeeFinances"
                                        class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/60 dark:border-gray-700/60 overflow-hidden"
                                    >
                                        <div class="divide-y divide-gray-200/60 dark:divide-gray-700/60">
                                            <div
                                                *ngFor="let item of employeeFinances"
                                                class="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer flex items-center justify-between gap-3"
                                                (click)="openEmployeeFinanceForm(item)"
                                            >
                                                <div class="min-w-0">
                                                    <p class="font-medium text-gray-900 dark:text-gray-100">
                                                        {{ item.financial_account?.title || 'Lançamento' }} · {{ formatBrl(item.value) }}
                                                    </p>
                                                    <p class="text-sm text-gray-500">
                                                        {{ formatFinanceDate(item.date) }} · {{ financeStatusLabel(item) }}
                                                        <span *ngIf="item.financial_account?.operation" class="ml-1">
                                                            · {{ item.financial_account.operation === 'ENTRADA' ? 'Entrada' : 'Saída' }}
                                                        </span>
                                                    </p>
                                                </div>
                                                <button
                                                    mat-icon-button
                                                    color="warn"
                                                    type="button"
                                                    (click)="deleteEmployeeFinance(item, $event)"
                                                    title="Remover"
                                                >
                                                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                </button>
                                            </div>
                                            <div *ngIf="employeeFinances.length === 0" class="px-4 py-10 text-center text-sm text-gray-500">
                                                <p>Nenhum lançamento cadastrado.</p>
                                                <p class="mt-1 text-xs text-gray-400">
                                                    Só aparecem lançamentos Outros com este funcionário em Funcionário.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </form>
                </div>
            </div>

            <!-- Loading Template -->
            <ng-template #loadingTemplate>
                <div class="w-full h-full flex items-center justify-center">
                    <mat-spinner></mat-spinner>
                </div>
            </ng-template>
        </ng-container>
    </div>

    <!-- Footer -->
    <ng-container *ngIf="!loadingData">
        <div class="flex items-center justify-center sm:justify-between px-6 py-4 bg-gray-100 dark:bg-black dark:bg-opacity-10 gap-2 flex-wrap">
            <div>
                <button (click)="deleteUser()" *ngIf="data?.user_id && loggedUser?.canDeleteRecords" mat-stroked-button [color]="'warn'">Remover</button>
            </div>
            <div></div>
            <div class="flex items-center gap-2 flex-wrap">
                <!-- Cancel -->
                <button (click)="clear()" mat-stroked-button [color]="'primary'" [matDialogClose]="'cancelled'">Fechar</button>
                <!-- Confirm -->
                <button (click)="done()" [disabled]="loading" [color]="'primary'" mat-flat-button>Salvar</button>
            </div>
        </div>
    </ng-container>
</div>
